import { Divider, Stack } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { BookingsSummary } from '../../Stores/VesselBookingsViewStore'
import { VesselBookingSummaryItem } from '../molecules/VesselBookingSummaryItem'

interface Props {
  data: BookingsSummary
}

export const VesselBookingSummary = observer(({ data }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const expectedLeftItem: { key: string; value: number }[] = [
    {
      key: t('total', 'Total'),
      value: data.expected.total,
    },
  ]

  const expectedRightItem: { key: string; value: number }[] = [
    {
      key: t('20ft', '20ft'),
      value: data.expected.twentyFeet,
    },
    {
      key: t('40ft', '40ft'),
      value: data.expected.fortyFeet,
    },
    {
      key: t('45ft', '45ft'),
      value: data.expected.fortyFiveFeet,
    },
  ]

  const onTerminalLeftItem: { key: string; value: number }[] = [
    {
      key: t('total', 'Total'),
      value: data.onTerminal.total,
    },
  ]

  const onTerminalRightItem: { key: string; value: number }[] = [
    {
      key: t('20ft', '20ft'),
      value: data.onTerminal.twentyFeet,
    },
    {
      key: t('40ft', '40ft'),
      value: data.onTerminal.fortyFeet,
    },
    {
      key: t('45ft', '45ft'),
      value: data.onTerminal.fortyFiveFeet,
    },
  ]

  return (
    <Stack
      direction='row'
      sx={{
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: '8px 8px 0px 0px',
        backgroundColor: theme.palette.grey[200],
      }}
    >
      <VesselBookingSummaryItem
        label={t('expected', 'Expected')}
        leftItems={expectedLeftItem}
        rightItems={expectedRightItem}
      />
      <Divider orientation='vertical' flexItem />
      <VesselBookingSummaryItem
        label={t('onTerminal', 'On terminal')}
        leftItems={onTerminalLeftItem}
        rightItems={onTerminalRightItem}
      />
    </Stack>
  )
})
